// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dqcNR","rootMobile":"styles_rootMobile__36mxn"};